import { Calendar, ConfigProvider } from "antd";
import classNames from "classnames";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { getFormattedLocale } from "@/features/calendar/model";
import type { Dayjs } from "dayjs";
import { CalendarHeader } from "../calendar-header";
import { CalendarFooter } from "../calendar-footer";
import { useCalendarViewDashboard } from "../hooks";
import { CellRenderDashboard } from "../cell-render";
import styles from "./styles.module.scss";

export const CalendarViewDashboard = () => {
  const { i18n } = useTranslation();
  const { selectedDate, onChange } = useCalendarViewDashboard();

  return (
    <div className={classNames(styles.wrapper, styles["wrapper--dashboard"])}>
      <ConfigProvider locale={getFormattedLocale(i18n.language)}>
        <Calendar
          value={dayjs(selectedDate)}
          className={classNames(
            styles.calendar,
            styles["calendar--dashboard"],
            styles["calendar-ru"],
          )}
          fullscreen={false}
          headerRender={({ value }) => <CalendarHeader value={value} />}
          fullCellRender={(value: Dayjs) => <CellRenderDashboard date={value} />}
          onChange={onChange}
        />
        <CalendarFooter />
      </ConfigProvider>
    </div>
  );
};
